import { useCallback } from 'react';
import Point from '@arcgis/core/geometry/Point';
import * as locator from '@arcgis/core/rest/locator';
import { observability } from 'utils/observability';
import { SpatialReferenceWgs84 } from 'components/MapPage/CorporateViewTabs/LayersTab/utils/spatialReference';

export const useReverseGeocode = () => {
  return useCallback(
    async (
      longitude: number,
      latitude: number
    ): Promise<{ address?: string; placeName?: string }> => {
      try {
        const candidate = await locator.locationToAddress(
          'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
          {
            location: new Point({
              longitude,
              latitude,
              spatialReference: SpatialReferenceWgs84,
            }),
          }
        );
        return {
          address: candidate?.address || undefined,
          placeName:
            candidate?.attributes?.PlaceName || candidate?.address || undefined,
        };
      } catch (error) {
        observability.captureException(error);
        return {};
      }
    },
    []
  );
};
